import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Prop } from 'vue-property-decorator';
import Util from '../../../lib/util';
import AbpBase from '../../../lib/AbpBase';
import Tenant from '@/store/entities/tenant';
var EditTenant = /** @class */ (function (_super) {
    __extends(EditTenant, _super);
    function EditTenant() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tenant = new Tenant();
        _this.tenantRule = {
            name: [{ required: true, message: _this.L('FieldIsRequired', undefined, _this.L('TenantName')), trigger: 'blur' }],
            tenancyName: [{ required: true, message: _this.L('FieldIsRequired', undefined, _this.L('TenancyName')), trigger: 'blur' }]
        };
        return _this;
    }
    EditTenant.prototype.save = function () {
        var _this = this;
        this.$refs.tenantForm.validate(function (valid) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!valid) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.$store.dispatch({
                                type: 'tenant/update',
                                data: this.tenant
                            })];
                    case 1:
                        _a.sent();
                        this.$refs.tenantForm.resetFields();
                        this.$emit('save-success');
                        this.$emit('input', false);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
    };
    EditTenant.prototype.cancel = function () {
        this.$refs.tenantForm.resetFields();
        this.$emit('input', false);
    };
    EditTenant.prototype.visibleChange = function (value) {
        if (!value) {
            this.$emit('input', value);
        }
        else {
            this.tenant = Util.extend(true, {}, this.$store.state.tenant.editTenant);
        }
    };
    __decorate([
        Prop({ type: Boolean, default: false })
    ], EditTenant.prototype, "value", void 0);
    EditTenant = __decorate([
        Component
    ], EditTenant);
    return EditTenant;
}(AbpBase));
export default EditTenant;
